module.exports = __webpack_public_path__ + "static/media/icon_panel_opened.92253ef3.svg";